import { Component, HostListener, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { MemberService } from 'src/app/services/member/member.service';
import { UserService } from 'src/app/services/user/user.service';
import { MemberHistoryComponent } from 'src/app/components/member-history/member-history.component';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    showUnloadDialog: boolean;
    showContinueMemberConfirmation: boolean;
    ref: DynamicDialogRef | undefined;

    constructor(
        private primengConfig: PrimeNGConfig,
        public userService: UserService,
        public memberService: MemberService,
        private readonly dialogService: DialogService
    ) {
        this.initializeErrorCatcher();
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        if (this.memberService.onCallSync) {
            this.showContinueMemberConfirmation = true;
        }

        this.memberService.showMemberHistory$.subscribe(show => {
            if (show) {
                this.openMemberHistoryDialog();
            }
        });
    }

    @HostListener('window:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.ctrlKey && event.key.toLowerCase() === 'h') {
            event.preventDefault();
            this.openMemberHistoryDialog();
        }
    }

    openMemberHistoryDialog() {
        this.ref = this.dialogService.open(MemberHistoryComponent, {
            header: 'Recent Members ',
            width: '35vw',
            height: '50vh',
            resizable: true,
            closable: true,
            closeOnEscape: true,
            styleClass: 'tw-rounded-lg'
        });
    }

    initializeErrorCatcher() {
        window.onerror = (msg, url, lineNo, columnNo, error) => {
            // ... handle error ...
            console.log(` ... handle error ... `);
            console.log(`Global Error Handling => `, msg, url, lineNo, columnNo, error);
            return false;
        };
    }



}
